import Axios2 from "@/utils/Axios2";
import axios from "axios";
import { getApiBaseUrl } from "@/utils/RuntimeConfig";

export default {
  /**
   * 获取报告基本信息（免登/独立页仅带报告编号时用来补齐报告名称、周期等头信息）
   * @param reportNumber 报告编号
   * @returns {Promise}
   */
  getReportInfo(reportNumber) {
    return Axios2.ajax({
      method: "get",
      url: "/api/v1/risk/report/info",
      params: {
        reportNumber: reportNumber,
      }
    });
  },

  /**
   * 获取报告统计数据
   * @param reportNumber 报告编号
   * @returns {Promise}
   */
  getReportSummary(reportNumber) {
    return Axios2.ajax({
      method: "get",
      url: "/api/v1/risk/monitor_site/statistic",
      params: {
        reportNumber: reportNumber,
      }
    });
  },

  /**
   * 获取监测点列表数据
   * @param params 查询参数
   * @returns {Promise}
   */
  getMonitorSiteList(params) {
    return Axios2.ajax({
      method: "get",
      url: "/api/v1/risk/monitor_site/data/list",
      params: params
    });
  },

  /**
   * 获取风险设备列表
   * @param reportNumber 报告编号
   * @returns {Promise}
   */
  getRiskDeviceList(reportNumber) {
    return Axios2.ajax({
      method: "get",
      url: "/api/v1/risk/monitor_site/risk_device/list",
      params: {
        reportNumber: reportNumber
      }
    });
  },



  /**
   * 下载PDF报告
   * @param reportNumber 报告编号
   * @returns {Promise}
   */
  downloadPDF(reportNumber) {
    return axios({
      method: 'get',
      url: getApiBaseUrl() + `/api/v1/risk/report/pdf/${reportNumber}`,
      responseType: 'blob'
    });
  },
  /**
   * 下载word报告
   * @param reportNumber 报告编号
   * @returns {Promise}
   */
  downloadWord(reportNumber) {
    return Axios2.ajax({
      method: 'get',
      url: `/api/v1/risk/report/word/${reportNumber}`,
    });
  }
}
